import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    /* --primary-blue: #00aed1; */
    --primary-blue: #006b67;
    --primary-bg-blue: #e6fcfb;
    --primary-lightGray: #f4f4f4;
    --primary-darkGray: #919191;
    --primary-darkerGray: #5f5f5f;
  }
`;
